import React, { useState, useEffect } from "react";
import "./Tickets.css";
import { useNavigate, useLocation } from "react-router-dom";
import BackBtn from "../../Components/BackBtn/BackBtn";
import HamburgerMenu from "../../Components/HamburgerMenu/HamburgerMenu";
import Badge from "react-bootstrap/Badge";
import BottomBar from "../../Components/BottomBar/BottomBar";
import Loading from "../../Components/Loading/Loading";
import { useAuth } from "../../AuthContext";
import Axios from "axios";
import { useBaseUrl } from "../../ApiContext";

export default function Tickets() {
  const { userToken } = useAuth();
  const baseUrl = useBaseUrl()
  const navigate = useNavigate();
  const location = useLocation();
  const { from } = location.state || {};
  const [showHamburgerMenu, setShowHamburgerMenu] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [ticketsList, setTicketsList] = useState([]);

  const hamburgerMenuHandler = () => {
    setShowHamburgerMenu(true);
  };

  const hideMenuHandler = () => {
    setShowHamburgerMenu(false);
  };

  const openChatHandler = (ticket) => {
    navigate(`/ticket/${ticket.id}`, { state: { id: ticket.id, from: from } });
  };

  useEffect(() => {
    const fetchTicketsList = async () => {
      try {
        const response = await Axios.get(
          `${baseUrl}/tickets`,
          {
            headers: {
              Authorization: `Token ${userToken}`,
            },
          }
        );
        setTicketsList(response.data.tickets);
        setIsLoading(false);
      } catch (error) {
        console.log("Error during getting tickets list", error);
      }
    };
    if (userToken) {
      fetchTicketsList();
    }
  }, [baseUrl, userToken]);

  const navigateToNewTicket = () => {
    navigate("/newTicket", { state: { from: from } });
  };

  return (
    <div className="gymBg bgContainer">
      <HamburgerMenu
        showHamburgerMenu={showHamburgerMenu}
        onHide={hideMenuHandler}
      />
      <div className="blurOverlay">
        <div className="pageWrapper">
          <div className="pageHeader centeredFlex">
            <BackBtn />
            <img
              src="/images/ic_menu.svg"
              alt="menu"
              className="menuIcon"
              onClick={hamburgerMenuHandler}
            />
          </div>
          <div className="pageTitle horizontalBorder">تیکت های پشتیبانی</div>
          <div className="ticketsContent centeredFlex">
            {isLoading ? (
              <Loading />
            ) : (
              <div
                className="ticketsContentTop centeredFlex scroll"
                style={
                  ticketsList.length > 0
                    ? { justifyContent: "flex-start" }
                    : { justifyContent: "center" }
                }
              >
                {ticketsList.length > 0 ? (
                  ticketsList.map((ticket) => (
                    <div
                      key={ticket.id}
                      className="ticket horizontalBorder centeredFlex"
                      onClick={() => openChatHandler(ticket)}
                    >
                      <div className="senderImgWrapper centeredFlex">
                        <img
                          src="/images/roundLogo.svg"
                          alt="sender"
                          className="senderImg"
                        />
                      </div>
                      <div className="ticketContent">
                        <span className="ticketSender">REDROSE</span>
                        <div className="ticketTitle">{ticket.title}</div>
                      </div>
                      {ticket.unread_count > 0 && (
                        <Badge className="newMessage" bg="#ff7269">
                          1 پیام جدید
                        </Badge>
                      )}
                    </div>
                  ))
                ) : (
                  <img
                    src="/images/ticketVector.png"
                    alt="ticket"
                    className=""
                  />
                )}
              </div>
            )}
            <div
              onClick={navigateToNewTicket}
              className="mainBtn ticketBtn submitNewTicketBtnMain"
            >
              ثبت تیکت جدید
            </div>
          </div>
        </div>
      </div>
      <BottomBar prevPath={from} />
    </div>
  );
}
